<template lang="pug">
  div(
    v-if="shortMode"
  ).e-location.short-mode
    input(
      v-show="showMapInShortMode"
      v-model="coordinates"
      :disabled="disableCoord"
      name="coordinates"
      @keyup.enter.prevent="$emit('enter')"
      @blur="$emit('blur')"
    )
    e-address(
    v-show="!showMapInShortMode"
    :placeholder="placeholder"
    :model="model"
    :name="name"
    :disabled="isFormDisabled"
    :addressData="addressData"
    :geoFields="geoFields"
    @selectItem="onSelectItem"
    @keyup.enter.prevent="$emit('enter')"
    @blur="$emit('blur')"
    )
    div(
      v-if="showMapToggleBtn"
    ).action-btns
      a(
        @click.stop.prevent="toggleMapInShortMode()"
        :title="$translate('Переключить режим ввода данных')"
      ).view-panel__button.view-map
    div.map-wrapper
      // set opacity and z-index for hide leaflet map block
      // with correct map and map center positions
      div(
        :style="{opacity: (showMapInShortMode ? 1 : 0), 'z-index': (showMapInShortMode ? 1000 : 0)}"
        ref="map"
      ).map
  div(
    v-else
  ).e-location
    div(:class="{'is-invalid': hasAddressError}").col-block
      label {{$translate('Местоположение')}} {{required ? '*' : ''}}
      e-address(
      @blur="checkValidateStatus()"
      :placeholder="placeholder"
      :model="model"
      :name="name"
      :disabled="isFormDisabled"
      :addressData="addressData"
      :geoFields="geoFields"
      @selectItem="onSelectItem"
      )
      span(v-if="hasAddressError").invalid.error {{ addressError }}
    div(:class="{'is-invalid': hasCoordError}").col-block.coord-block
      label {{$translate('Географические координаты')}} {{required ? '*' : ''}}
      input(
      @blur="checkValidateStatus()"
      v-model="coordinates"
      ref="coordinatesField"
      :disabled="disableCoord"
      :name="name + '.coordinates'"
      )
      span(v-if="hasCoordError").invalid.error {{ coordError }}
    div.col-block.map-block
      div.map(ref="map")
</template>

<script>
  import router from '../../routes/index'
  import permissionMixin from '../../mixins/permission-mixin.js'
  import {FORCE_ENABLE_DISABLED_FIELDS} from '../../config/config.js'

  import * as L from 'leaflet'
  import {TILE_LAYER} from '../../config/map.js'

  // fix: leaflet default icon wrong path
  // https://github.com/Leaflet/Leaflet/issues/4968
  import markerIcon from 'leaflet/dist/images/marker-icon.png'
  import iconShadow from 'leaflet/dist/images/marker-shadow.png'
  const MARKER_ICON = L.icon({
    iconUrl: markerIcon,
    shadowUrl: iconShadow,
    iconAnchor: [10, 42]
  })
  MARKER_ICON.options.shadowSize = [0, 0]

  const DEFAULT_INVALID_LAT = 0
  const DEFAULT_INVALID_LNG = 0

  export default {
    name: 'e-location',
    mixins: [permissionMixin],
    data () {
      return {
        coordinates: '',
        coordError: null,
        addressError: null
      }
    },
    props: {
      placeholder: {
        type: String,
        default: ''
      },
      shortMode: {
        type: Boolean,
        default: false
      },
      showMapToggleBtn: {
        type: Boolean,
        default: false
      },
      geoFields: {
        type: Array,
        default: function () {
          return ['latitude', 'longitude']
        }
      },
      freezeLatLng: {
        type: Boolean,
        default: false
      },
      mapId: {
        type: String,
        default: 'map'
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null,
        required: true
      },
      /* addressName */
      name: {
        type: String,
        default: null,
        required: true
      },
      validationRule: {
        type: String,
        default: 'string'
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      /* coordinates: {
        required: true
      }, */
      addressData: {
        type: Object,
        default: function () {
          return {}
        },
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      coordinates () {
        [this.model[this.geoFields[0]], this.model[this.geoFields[1]]] = this.coordinates.split(/[ ,]+/)
        if (!this.markerDragging) {
          this.checkValidateStatus()
          this.updateMarkerPosition()
          this.emmit('coordinatesChange', this.coordinates)
        }
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
      this.setCoordinates()
      this.$watch('model.' + this.geoFields[0], () => {
        this.setCoordinates()
      })
      this.$watch('model.' + this.geoFields[1], () => {
        this.setCoordinates()
      })
    },
    mounted () {
      this.createMap()
    },
    computed: {
      arrayCoords () {
        return [this.model[this.geoFields[0]] || DEFAULT_INVALID_LAT, this.model[this.geoFields[1]] || DEFAULT_INVALID_LNG]
      },
      showMapInShortMode () {
        return this.model._showMapForFields && this.model._showMapForFields.indexOf(this.name) > -1
      },
      isFormDisabled () {
        if (FORCE_ENABLE_DISABLED_FIELDS === true) {
          return false
        }
        if (this.disabled) {
          return true
        }
        let name = router.history.current.name
        let formState = this.$sharedServices.store.getters.formState(name, 'disabledForms')
        if (!formState) {
          formState = !this.userCanWrite
        }
        return formState
      },
      disableCoord () {
        if (FORCE_ENABLE_DISABLED_FIELDS === true) {
          return false
        }
        if (this.freezeLatLng || this.isFormDisabled) {
          return true
        }
        return false
      },
      form () {
        let parent = this.$parent
        let parentName = parent.$options.name
        while (parentName !== 'e-form') {
          parent = parent.$parent
          parentName = parent.$options.name
        }
        return parent
      },
      hasAddressError () {
        if (this.addressError) {
          return true
        }
        return false
      },
      hasCoordError () {
        if (this.coordError) {
          return true
        }
        return false
      }
    },
    methods: {
      onSelectItem ({data}) {
        if (this.disableCoord === false) {
          this.setCoordinates([data.geo_lat, data.geo_lon], true)
        }
        this.emmit('locationChange', data)
        this.checkValidateStatus()
      },
      updateMarkerPosition () {
        try {
          let latlng = L.latLng(this.arrayCoords)
          this.marker.setLatLng(latlng)
          this.map.panTo(latlng)
        } catch (e) {
          console.warn(e.toString())
        }
      },
      createMap () {
        let latlng = null
        try {
          latlng = L.latLng(this.arrayCoords)
        } catch (e) {
          latlng = L.latLng(DEFAULT_INVALID_LAT, DEFAULT_INVALID_LNG)
          this.coordError = 'Некорректные координаты'
        }
        this.map = L.map(this.$refs.map, {
          center: latlng,
          zoom: 15
        })
        L.tileLayer(TILE_LAYER, {}).addTo(this.map)
        this.marker = L.marker(latlng, {
          draggable: !this.disableCoord,
          icon: MARKER_ICON
        }).addTo(this.map)
        this.marker.on('dragstart', () => {
          this.markerDragging = true
        })
        this.marker.on('drag', () => {
          let ll = this.marker.getLatLng()
          this.setCoordinates([ll.lat, ll.lng])
        })
        this.marker.on('dragend', () => {
          this.markerDragging = false
          let ll = this.marker.getLatLng()
          this.setCoordinates([ll.lat, ll.lng])
        })
      },
      checkValidateStatus () {
        if (this.hasAddressError || this.hasCoordError) {
          this.validate()
        }
      },
      toggleMapInShortMode () {
        let _showMapForFields = this.model._showMapForFields || []
        if (_showMapForFields && _showMapForFields.indexOf(this.name) > -1) {
          _showMapForFields = _showMapForFields.filter(name => name != this.name)
        } else {
          _showMapForFields.push(this.name)
        }
        this.$set(this.model, '_showMapForFields', _showMapForFields)
      },
      getElement () {
        return this.$refs.address
      },
      setCoordinates (latLng) {
        // console.log(latLng);
        latLng = latLng || [this.model[this.geoFields[0]], this.model[this.geoFields[1]]];
        this.coordinates = latLng.join(', ')
        if (this.coordinates === ', ') {
          this.coordinates = `${DEFAULT_INVALID_LAT}, ${DEFAULT_INVALID_LNG}`
        }
        if (!this.markerDragging) {
          this.emmit('coordinatesChange', this.coordinates)
          this.checkValidateStatus()
        }
      },
      emmit (action, data) {
        this.$emit(action, data)
        this.$emitter.emit('e-location.' + action, data)
      },
      validate () {
        this.coordError = null
        this.addressError = null
        let focusOnAddress = false

        if (this.required) {
          if (!this.model[this.name] || this.model[this.name].length < 1) {
            this.addressError = 'Укажите адрес. '
            focusOnAddress = true
          }

          if (!this.coordinates) {
            if (this.addressError) {
              this.coordError = 'Укажите адрес, чтобы появились координаты. '
            } else {
              this.addressError = 'Снова выберите адрес, чтобы появились координаты. '
              this.coordError = 'Либо укажите координаты вручную, например: 55.7, 37.6 '
            }
          } else if (this.coordinates.length < 5 || this.coordinates.split(',').length !== 2) {
            this.coordError = 'Укажите корректные координаты, например: 55.7, 37.6 '
          } else if (this.coordinates.split(',').length === 2) {
            let [lat, lng] = this.coordinates.split(',')
            if (isNaN(lat) || isNaN(lng) || Math.abs(lat) < 1 || Math.abs(lat) > 200 || Math.abs(lng) < 1 || Math.abs(lng) > 200) {
              this.coordError = 'Укажите корректные координаты, например: 55.7, 37.6 '
            }
          }
        }

        if (focusOnAddress === true) {
          return {
            error: this.addressError,
            tabView: this.tabView,
            name: this.name,
            modalVariableName: this.modalVariableName,
            el: this.getElement()
          }
        }

        return {
          error: this.coordError,
          tabView: this.tabView,
          name: this.name + '.coordinates',
          modalVariableName: this.modalVariableName,
          el: this.$refs.coordinatesField
        }
      }
    }
  }
</script>
